import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputGroupWrapper from '../../InputGroupWrapper';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';
import NumberInput from '../../input/NumberInput';

const convertPercentage = val => {
  const parsedValue = parseFloat(val);
  if (Number.isNaN(parsedValue)) return null;
  return (Math.abs(parsedValue) / 100).round(4);
};

const DiscountPart = ({ discount, onChange, disabled, className }) => (
  <FormGroupPart label={messages.Discount}>
    <InputGroupWrapper
      className={classnames('input-group-sm', { disabled: disabled }, className)}
      left="%"
    >
      <NumberInput
        id="quantityField"
        min={0}
        max={100}
        disabled={disabled}
        value={((discount || 0) * 100).round(2)}
        onChange={value => onChange(convertPercentage(value))}
        className="form-control input-sm"
      />
    </InputGroupWrapper>
  </FormGroupPart>
);
DiscountPart.propTypes = {
  discount: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
DiscountPart.defaultProps = {
  discount: 0,
  disabled: false,
  className: '',
};
export default DiscountPart;
